import React from "react";
import { Input } from "../Input";
import { Flex } from "../Flex";
import { Heading } from "../Heading";
import { EditIcon } from "../icons";
import { useToggle } from "../../hooks";

// TODO (at): add/update EditableHeader as and size props
const EditableHeader: React.FunctionComponent<{
  cell: { type: string; value?: string; placeholder: string };
  onEdit: (newValue: string) => void;
}> = ({ cell, onEdit }) => {
  const { isOpen, onOpen, onClose } = useToggle();
  return isOpen ? (
    <Input
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus={true}
      autoComplete="new-password"
      onBlur={async (e: React.FormEvent<EventTarget>) => {
        const target = e.currentTarget as HTMLInputElement;
        await onEdit(target.value);
        isOpen && onClose();
      }}
      onKeyDown={async (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.keyCode === 13) {
          const target = e.currentTarget;
          await onEdit(target.value);
          isOpen && onClose();
        }
      }}
      type={cell.type}
      defaultValue={cell.value}
      placeholder={cell.placeholder}
      sx={{
        fontSize: "2.5rem",
        mx: "2px",
      }}
    />
  ) : (
    <Flex
      onClick={onOpen}
      align="flex-end"
      sx={{
        px: 3,
        py: 2,
        width: "fit-content",
        ":hover": {
          cursor: "pointer",
          color: "primary",
          svg: {
            display: "block",
          },
        },
      }}
    >
      <Heading as="h1" fontWeight="normal">
        {cell.value}
      </Heading>
      <EditIcon
        size="40px"
        sx={{
          display: "none",
          mb: "3px",
        }}
      />
    </Flex>
  );
};

export default EditableHeader;
